"use client";

import { useTranslations } from "next-intl";

/**
 * Real customer quotes (the home page case studies). Replaces the former
 * placeholder testimonial avatars on the contact and auth side panels.
 */
export function CustomerQuotes({ className }: { className?: string }) {
  const cs = useTranslations("caseStudies");
  const quotes = [
    { quote: cs("cs1_quote"), attrib: `${cs("cs1_quote_attrib")} · ${cs("cs1_company")}` },
    { quote: cs("cs2_quote"), attrib: `${cs("cs2_quote_attrib")} · ${cs("cs2_company")}` },
  ];
  return (
    <div className={className ?? "mb-10 space-y-6"}>
      {quotes.map((q) => (
        <figure key={q.attrib} className="border-l-2 border-red-500/60 pl-4 text-left">
          <blockquote className="text-sm leading-relaxed text-neutral-700 dark:text-neutral-200">“{q.quote}”</blockquote>
          <figcaption className="mt-2 text-xs text-neutral-500">{q.attrib}</figcaption>
        </figure>
      ))}
    </div>
  );
}
